export const metrcKeys = {
  all: ['metrc'] as const,
  config: (queryProps?: any) => [...metrcKeys.all, 'config'].concat(queryProps ?? []),
  oldestHarvest: (queryProps?: any) => [...metrcKeys.all, 'oldest-harvest'].concat(queryProps ?? []),
  syncDate: (queryProps?: any) => [...metrcKeys.all, 'get-last-sync-dates'].concat(queryProps ?? []),
  processingJobTypes: (queryProps?: any) => [...metrcKeys.all, 'processing-job-types'].concat(queryProps ?? []),
};
